import { css, LitElement, html } from "lit";
import { property, customElement } from "lit/decorators.js";
import "./promotional-header.js";
import { when } from "lit/directives/when.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let OfferAccordionHeader = class extends LitElement {
  constructor() {
    super(...arguments);
    this.checked = false;
    this.showIcon = true;
    this.showPromotionalHeader = true;
  }
  change(e) {
    this.dispatchEvent(new Event(e.type, e));
  }
  render() {
    return html`
      <label>
        <input type="radio" .checked=${this.checked} @change=${this.change}>
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 16 16" fill="currentColor"><circle data-name="ellipse" cx="8" cy="8" r="8"></circle></svg>
        </span> 
        ${when(this.showPromotionalHeader, () => html`
          <promotional-header .quote=${this.quote}>
            <slot></slot>
          </promotional-header>
        `, () => html`
          <slot></slot>
        `)}
      </label>
  `;
  }
};
OfferAccordionHeader.styles = css`

    input[type=radio] {
      scale: var(--default-vi-action-radio-scale);
      height: 16px;
      aspect-ratio: 1;
      border-width: 1px;
      border-color: var(--default-vi-action-accept-border-color);
      border-style: solid;
      border-radius: 50%;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      cursor: pointer;
      font-size: inherit;
      transition: .3s;
      margin: 0 8px 0 0;
      background-color: #ffffff;
    }

    label span {
      color: var(--default-vi-action-accept-radio-color);
      position: absolute;
      width: 0px;
      height: 0px;
      line-height: 0px;
      opacity: 1;
      width: 10px;
      height: 10px;
      left: 3px;
      transform: scale(0);
    }

    input[type=radio]:checked + span {
      transform: scale(var(--default-vi-action-radio-scale));
      transition: 120ms transform ease-in-out;
    }
  
    label {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 0;
      position: relative;
      border-radius: var(--default-vi-action-border-radius);
      font-family: var(--default-vi-font-family);
      font-size: var(--default-vi-font-md);
      min-height: 27px;
    }

    promotional-header {
      width: 100%;
    }
    .icon svg {
      margin-top: 2px;
      margin-left: 5px;
    }
  `;
__decorateClass([
  property({ type: Number })
], OfferAccordionHeader.prototype, "type", 2);
__decorateClass([
  property({ type: Boolean })
], OfferAccordionHeader.prototype, "checked", 2);
__decorateClass([
  property({ type: Boolean })
], OfferAccordionHeader.prototype, "showIcon", 2);
__decorateClass([
  property({ type: Boolean })
], OfferAccordionHeader.prototype, "showPromotionalHeader", 2);
__decorateClass([
  property({ attribute: false })
], OfferAccordionHeader.prototype, "quote", 2);
OfferAccordionHeader = __decorateClass([
  customElement("offer-radio-header")
], OfferAccordionHeader);
export {
  OfferAccordionHeader
};
